import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/52-week-money-challenge',
  component: () => import('../../routes/WeeklySavings.svelte'),
  card: {
    id: '52-week-money-challenge',
    title: '52-Week Money Challenge',
    description:
      'Save $1,378 in 52 weeks by increasing your weekly savings by $1 each week — or start high and work your way down.',
    icon: 'savings',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/52-week-money-challenge',
    category: 'Savings & Investing',
  },
  seo: {
    title: '52-Week Money Challenge Calculator – Save $1,378 in a Year',
    description:
      'Free 52-Week Money Challenge calculator. Track your progress saving $1,378 in 52 weeks with the popular ascending or descending savings method.',
  },
};

export default meta;